<template>
  <div id="root">
    <header>
      <!-- <Publicity v-show="!running" /> -->
      <div style="width: 200px;">
        <el-button
          :disabled="running"
          class="res"
          type="text"
          @click="showResult = true"
        >
          抽签结果
        </el-button>
        <Tool
          ref="toolRef"
          class="con"
          :running="running"
          :closeRes="closeRes"
          @toggle="toggle"
          @resetConfig="reloadTagCanvas"
          @getPhoto="getPhoto"
          @show-config="showConfig = true"
          @reset-category="resetCategory"
        />
      </div>

      <!-- 播放背景音 -->
      <div style="width: 150px;">
        <el-button
          class="audio"
          type="text"
          @click="
            () => {
              playAudio(!audioPlaying);
            }
          "
        >
          <i
            class="iconfont"
            :class="[audioPlaying ? 'iconstop' : 'iconplay1']"
          ></i>
        </el-button>
        <el-button
          class="start"
          @click="startHandler"
          type="primary"
          size="mini"
        >
          {{ running ? '停止' : '开始' }}
        </el-button>
      </div>
    </header>
    <div id="main" :class="{ mask: showRes }"></div>

    <!-- 当前抽奖的奖品信息 -->
    <v-prize :category="category" :category-name="categoryName" />

    <!-- 抽奖的 tag -->
    <div id="tags">
      <ul v-for="item in datas" :key="item.key">
        <li>
          <a
            href="javascript:void(0);"
            :style="{
              color: '#fff'
            }"
          >
            {{ item.name ? item.name : item.key }}
            <img v-if="item.photo" :src="item.photo" :width="50" :height="50" />
          </a>
        </li>
      </ul>
    </div>

    <!-- 当前抽奖的结果 -->
    <transition name="bounce">
      <div id="resbox" v-show="showRes">
        <p @click="showRes = false">{{ categoryName }}</p>
        <div class="container">
          <span
            v-for="item in resArr"
            :key="item"
            class="itemres"
            :style="resCardStyle"
            :data-id="item"
            @click="showRes = false"
          >
            <!-- :class="{
              numberOver:
                !!photos.find(d => d.id === item) ||
                !!list.find(d => d.key === item)
            }" -->
            <template v-if="photos.find(d => d.id === item)">
              <img
                :src="photos.find(d => d.id === item).value"
                :width="160"
                :height="160"
                alt="photo"
              />
              <span class="re-image-label">
                {{ photos.find(d => d.id === item).name }}
              </span>
            </template>
            <span v-else class="cont">
              <span
                v-if="!!list.find(d => d.key === item)"
                :style="{
                  fontSize: '40px'
                }"
              >
                {{ list.find(d => d.key === item).name }}
              </span>
              <span v-else>
                {{ item }}
              </span>
            </span>
          </span>
        </div>
      </div>
    </transition>

    <LotteryConfig
      @getPhoto="getPhoto"
      @resetconfig="reloadTagCanvas"
      :visible.sync="showConfig"
    />
    <!-- <Tool
      @toggle="toggle"
      @resetConfig="reloadTagCanvas"
      @getPhoto="getPhoto"
      :running="running"
      :closeRes="closeRes"
    /> -->

    <!-- 抽奖接口汇总 -->
    <Result :visible.sync="showResult"></Result>
    <audio
      id="audiobg"
      preload="auto"
      controls
      autoplay
      loop
      @play="playHandler"
      @pause="pauseHandler"
    >
      <source :src="audioSrc" />
      你的浏览器不支持 audio 标签
    </audio>
  </div>
</template>

<style>
  .cont span{font-size:23px !important;line-height:34px}
</style>
<script>
import LotteryConfig from '@/components/LotteryConfig';
// import Publicity from '@/components/Publicity';
import Tool from '@/components/Tool';
import VPrize from '@/components/VPrize';
import bgaudio from '@/assets/bg.mp3';
// import beginaudio from '@/assets/begin.mp3';
import beginaudio from '@/assets/百石元 - 猪突猛進.mp3';
import {
  getData,
  configField,
  resultField,
  newLotteryField,
  conversionCategoryName,
  listField
} from '@/helper/index';
import { lotteryHandler } from '@/helper/algorithm';
import Result from '@/components/Result';
import { database, DB_STORE_NAME } from '@/helper/db';
export default {
  name: 'App',
  components: {
    LotteryConfig,
    Tool,
    Result,
    VPrize
  },
  data() {
    return {
      running: false,
      showRes: false,
      showConfig: false,
      showResult: false,
      resArr: [],
      category: '',
      audioPlaying: false,
      audioSrc: bgaudio
    };
  },
  watch: {
    photos: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.reloadTagCanvas();
        });
      }
    }
  },
  computed: {
    resCardStyle() {
      const style = { fontSize: '30px' };
      const { number } = this.config;
      if (number < 100) {
        style.fontSize = '100px';
      } else if (number < 1000) {
        style.fontSize = '80px';
      } else if (number < 10000) {
        style.fontSize = '60px';
      }

      style.marginRight = this.resArr.length > 1 ? '20px' : 0;
      return style;
    },
    config: {
      get() {
        return this.$store.state.config;
      }
    },
    result: {
      get() {
        return this.$store.state.result;
      },
      set(val) {
        this.$store.commit('setResult', val);
      }
    },
    list() {
      return this.$store.state.list;
    },
    allresult() {
      let allresult = [];
      for (const key in this.result) {
        if (this.result.hasOwnProperty(key)) {
          const element = this.result[key];
          allresult = allresult.concat(element);
        }
      }
      return allresult;
    },
    datas() {
      const { number } = this.config;
      const nums = number >= 1500 ? 500 : this.config.number;
      const configNum = number > 1500 ? Math.floor(number / 3) : number;
      const randomShowNums = lotteryHandler(configNum, [], nums);
      const randomShowDatas = randomShowNums.map(item => {
        const listData = this.list.find(d => d.key === item);
        const photo = this.photos.find(d => d.id === item);
        return {
          key: item * (number > 1500 ? 3 : 1),
          name: listData ? listData.name : '',
          photo: photo ? photo.value : ''
        };
      });
      console.log(randomShowDatas);
      return randomShowDatas;
    },
    categoryName() {
      return conversionCategoryName(this.category);
    },
    photos() {
      return this.$store.state.photos;
    },
    currentPrize() {
      if (!this.category) {
        return '';
      }

      // const key = `${this.category}__prize`;
      const item = this.photos.find(i => i.id === this.category);
      return item ? item.value : '';
    }
  },
  created() {
    const data = getData(configField);
    if (data) {
      this.$store.commit('setConfig', Object.assign({}, data));
    }

    const result = getData(resultField);
    if (result) {
      this.$store.commit('setResult', result);
    }

    const newLottery = getData(newLotteryField);
    if (newLottery) {
      const config = this.config;
      newLottery.forEach(item => {
        this.$store.commit('setNewLottery', item);
        if (!config[item.key]) {
          this.$set(config, item.key, 0);
        }
      });
      this.$store.commit('setConfig', config);
    }

    const list = getData(listField);
    if (list) {
      this.$store.commit('setList', list);
    }
  },
  mounted() {
    this.startTagCanvas();
    setTimeout(() => {
      this.getPhoto();
    }, 1000);
    window.addEventListener('resize', this.reportWindowSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.reportWindowSize);
  },
  methods: {
    resetCategory() {
      this.category = '';
    },
    startHandler() {
      this.toggle();
      this.$refs.toolRef.startHandler();
    },
    reportWindowSize() {
      const AppCanvas = this.$el.querySelector('#rootcanvas');
      if (AppCanvas.parentElement) {
        AppCanvas.parentElement.removeChild(AppCanvas);
      }

      this.startTagCanvas();
    },
    playHandler() {
      this.audioPlaying = true;
    },
    pauseHandler() {
      this.audioPlaying = false;
    },
    playAudio(type) {
      if (type) {
        this.$el.querySelector('#audiobg').play();
      } else {
        this.$el.querySelector('#audiobg').pause();
      }
    },
    loadAudio() {
      this.$el.querySelector('#audiobg').load();
      this.$nextTick(() => {
        this.$el.querySelector('#audiobg').play();
      });
    },
    getPhoto() {
      database.getAll(DB_STORE_NAME).then(res => {
        if (res && res.length) {
          this.$store.commit('setPhotos', res);
        }
      });
    },
    speed() {
      return [0.1 * Math.random() + 0.01, -(0.1 * Math.random() + 0.01)];
    },
    createCanvas() {
      const canvas = document.createElement('canvas');
      canvas.width = document.body.offsetWidth;
      canvas.height = document.body.offsetHeight;
      canvas.id = 'rootcanvas';
      this.$el.querySelector('#main').appendChild(canvas);
    },
    startTagCanvas() {
      this.createCanvas();
      const { speed } = this;
      window.TagCanvas.Start('rootcanvas', 'tags', {
        textColour: null,
        initial: speed(),
        dragControl: 1,
        textHeight: 20,
        noSelect: true,
        lock: 'xy'
      });
    },
    reloadTagCanvas() {
      window.TagCanvas.Reload('rootcanvas');
    },
    closeRes() {
      this.showRes = false;
    },
    toggle(form) {
      const { speed, config } = this;
      if (this.running) {
        this.audioSrc = bgaudio;
        this.loadAudio();

        window.TagCanvas.SetSpeed('rootcanvas', speed());
        this.showRes = true;
        this.running = !this.running;
        this.$nextTick(() => {
          this.reloadTagCanvas();
        });
      } else {
        this.showRes = false;
        if (!form) {
          return;
        }

        this.audioSrc = beginaudio;
        this.loadAudio();

        const { number } = config;
        const { category, mode, qty, remain, allin } = form;

        // 本次抽取人数
        let num = 1;
        if (mode === 1 || mode === 5) {
          num = mode;
        } else if (mode === 0) {
          num = remain;
        } else if (mode === 99) {
          num = qty;
        }
        const resArr = lotteryHandler(
          number,
          // eslint-disable-next-line
          allin ? [] : this.allresult,
          num
        );
        this.resArr = resArr;

        this.category = category;
        if (!this.result[category]) {
          this.$set(this.result, category, []);
        }
        const oldRes = this.result[category] || [];
        const data = Object.assign({}, this.result, {
          [category]: oldRes.concat(resArr)
        });
        this.result = data;
        window.TagCanvas.SetSpeed('rootcanvas', [5, 1]);
        this.running = !this.running;
      }
    }
  }
};
</script>
<style lang="scss">
#root {
  height: 100%;
  position: relative;
  background-image: url('./assets/primary-vision-2.jpg');
  background-size: 100% 100%;
  background-position: center center;
  background-repeat: no-repeat;
  background-color: #121936;
  .mask {
    -webkit-filter: blur(5px);
    filter: blur(5px);
  }
  header {
    justify-content: space-between;
    display: flex;
    position: absolute;
    width: 100%;
    height: 50px;
    bottom: 0;
    line-height: 50px;
    .con {
      bottom: 30px;
    }
    .el-button {
      position: absolute;
      z-index: 9999;
      &.res {
        left: 90px;
      }
    }
    .start {
      right: 20px;
      margin-top: 2px;
      background-color: #2941c0;
      border-color: #2941c0;
    }
    .audio {
      position: absolute;
      right: 90px;
      width: 34px;
      height: 34px;
      line-height: 34px;
      border: 1px solid #fff;
      border-radius: 50%;
      padding: 0;
      text-align: center;
      .iconfont {
        position: relative;
        left: 1px;
      }
    }
  }
  .bounce-enter-active {
    animation: bounce-in 1.5s;
  }
  .bounce-leave-active {
    animation: bounce-in 0s reverse;
  }
}
#main {
  height: 100%;
}

#resbox {
  position: absolute;
  // height: 100%;
  max-height: 100%;
  overflow: auto;
  top: 50%;
  left: 50%;
  width: 1280px;
  transform: translateX(-50%) translateY(-50%);
  text-align: center;
  p {
    color: white;
    font-size: 50px;
    line-height: 120px;
    font-weight: 500;
  }
  .container {
    // height: 80%;
    // overflow: auto;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
  .itemres {
    background: #fff;
    width: 160px;
    height: 160px;
    border-radius: 4px;
    border: 1px solid #ccc;
    line-height: 160px;
    font-weight: bold;
    // margin-right: 20px;
    margin-bottom: 40px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .cont {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &.numberOver::before {
      content: attr(data-id);
      width: 30px;
      height: 22px;
      line-height: 22px;
      background-color: #fff;
      position: absolute;
      bottom: 0;
      left: 0;
      font-size: 14px;
      // border-radius: 50%;
      z-index: 1;
    }
    .re-image-label {
      font-size: 24px;
      line-height: 24px;
      color: #f5f7fa;
      position: absolute;
      bottom: -28px;
    }
  }
}

// .prize-preview {
//   position: absolute !important;
//   bottom: 0;
//   right: 0;
//   width: 200px;
//   height: 160px;
// }
</style>
